import AssistantPanelAskButton from "components/AssistantPanel/AskButton";
import { buildLoginPolicyOverviewPrompt } from "components/AssistantPanel/prompts";
import Box from "ds/components/Box";
import Tooltip from "ds/components/Tooltip";
import Typography from "ds/components/Typography";

type LoginPolicyDetailsAskButtonProps = {
  policyId: string;
};

const LoginPolicyDetailsAskButton = ({ policyId }: LoginPolicyDetailsAskButtonProps) => (
  <Tooltip
    widthMode="maxWidthSm"
    on={(props) => (
      <AssistantPanelAskButton
        {...props}
        entryPoint="login_policy_overview"
        prompt={buildLoginPolicyOverviewPrompt({ policyId })}
        id="login-policy-view--ask-infra-assistant"
      />
    )}
  >
    <Box direction="column" gap="small">
      <Typography tag="p">Ask Infra Assistant</Typography>
      <Typography tag="p">
        Get a <b>quick summary</b> of <b>this login policy</b>: who can log in, what access it
        grants and what needs attention.
      </Typography>
    </Box>
  </Tooltip>
);

export default LoginPolicyDetailsAskButton;
